import api from '../../api'
import { toHiragana, toKatakana } from './utils'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  getAllChildren: (state) => {
    return flatten(state.all)
  },
  getAllForList: (state) => state.all.filter((g) => g.menu),
  getAllForPlanTop: (state) => {
    return flatten(state.all).filter(genre => genre.planTop)
  },
  getParentGenreIds: (state) => state.all.map((genre) => genre.id ),
  getAllWithoutEmpty: (state, _getters, _rootState, rootGetters) => {
    return state.all.filter((genre) => {
      return rootGetters['places/getPlacesByGenre'](genre).length > 0
    })
  },
  search: (state) => (word) => {
    return state.all
      .filter(genre => genre.menu)
      .flatMap(genre => genre.children)
      .filter(genre => isMatch(genre, word))
  },
  getFavoriteGenre: (state) => {
    return state.all.find(genre => genre.type === "favorite")
  }
}

const actions = {
  fetchAll ({ rootGetters, commit, dispatch }) {
    return new Promise((resolve) => {
      api.getGenres(rootGetters['user/getLang'])
        .then((genres) => {
          dispatch('user/updateFilter', genres, { root: true })
          commit('setGenres', genres)
          resolve()
        })
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setGenres (state, genres) {
    state.all = genres
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

/**
 * Private function
 */

function isMatch(genre, word) {
  const hiragana = toHiragana(word)
  const katakana = toKatakana(word)

  // NOTE: 呼び出し元でchildrenがないジャンルの場合flatMapするとundefinedがはいってしまうため
  if (!genre) return false

  return genre.name.indexOf(hiragana) > -1 ||
    genre.name.indexOf(katakana) > -1
}

function flatten(genres) {
  let a = []
  genres.forEach(genre => {
    a.push(genre)
    if (genre.children) a.push(genre.children)
  })
  return a.flat()
}
